import i18n from "@swa-ui/locale";
import { filter } from "@swa-ui/object";

import { ALL_OTHERS, ALL_RAPID_REWARDS, NO_PREFERENCE } from "../../../defines/vendorGroups";
import styles from "./carVendorData.module.scss";

export const useCarVendorData = (carVendorData) => {
  function getVendorNameFromId(vendorId) {
    return carVendorData[vendorId]?.name || vendorId;
  }

  function vendorListMap(vendorId) {
    return {
      displayName: getVendorNameFromId(vendorId),
      indent: true,
      label: getVendorNameFromId(vendorId),
      value: vendorId,
    };
  }

  function getNoPreference() {
    return {
      className: styles.separator,
      displayName: i18n("CarBookingForm__TEXT_ALL"),
      label: i18n("CarBookingForm__TEXT_ALL"),
      value: NO_PREFERENCE,
    };
  }

  function getRapidRewards() {
    return {
      displayName: i18n("CarBookingForm__TEXT_ALL_RAPID_REWARDS_PARTNERS"),
      label: i18n("CarBookingForm__TEXT_ALL_RAPID_REWARDS_PARTNERS"),
      value: ALL_RAPID_REWARDS,
    };
  }

  function getAllOthers() {
    return {
      displayName: i18n("CarBookingForm__TEXT_ALL_OTHERS"),
      label: i18n("CarBookingForm__TEXT_ALL_OTHERS"),
      value: ALL_OTHERS,
    };
  }

  function getRapidRewardsVendorIds(vendorData) {
    const vendors = filter(vendorData, (vendor) => vendor.rapidRewardsPartner);

    return Object.keys(vendors);
  }

  function getNonRapidRewardsVendorIds(vendorData) {
    const vendors = filter(vendorData, (vendor) => !vendor.rapidRewardsPartner);

    return Object.keys(vendors);
  }

  return {
    vendorListMap,
    getVendorNameFromId,
    getRapidRewardsVendorIds,
    getNonRapidRewardsVendorIds,
    getNoPreference,
    getRapidRewards,
    getAllOthers,
  };
};
